export default "__VITE_ASSET__CWRQZOxB__"